<section
  class="paid-past-query-sheet tw-flex tw-flex-col tw-overflow-hidden tw-bg-gray-100 tw-font-lexend tw-shadow-z13"
  [class.paid-past-query-sheet-full-page]="isFullPage()"
  [class.paid-past-query-sheet-settling]="isSettling()"
  [style.height]="sheetHeight()"
  [style.border-radius]="isFullPage() ? '0' : '24px 24px 0 0'"
  style="touch-action: pan-y;"
  (wheel)="onWheel($event, queryList.scrollTop)"
  (touchstart)="onTouchStart($event)"
  (touchmove)="onTouchMove($event, queryList.scrollTop)"
  (touchend)="onTouchEnd()"
  (touchcancel)="onTouchEnd()"
  (pointerdown)="onPointerDown($event)"
  (pointermove)="onPointerMove($event, queryList.scrollTop)"
  (pointerup)="onPointerEnd()"
  (pointercancel)="onPointerEnd()"
  (transitionend)="onTransitionEnd($event)"
>
  <header
    class="tw-flex tw-flex-none tw-items-center tw-px-6 tw-pt-8 tw-pb-4"
    [class.tw-justify-between]="!isFullPage()"
    [class.tw-gap-4]="isFullPage()"
  >
    <button
      type="button"
      [attr.aria-label]="isFullPage() ? 'Back' : 'Close'"
      class="tw-m-0 tw-flex tw-min-w-0 tw-items-center tw-justify-center tw-p-0"
      [class.tw-order-1]="isFullPage()"
      [class.tw-order-2]="!isFullPage()"
      [class.tw-h-10]="isFullPage()"
      [class.tw-w-10]="isFullPage()"
      [class.tw-rounded-xl]="isFullPage()"
      [class.tw-bg-gray-800]="isFullPage()"
      [class.tw-text-white]="isFullPage()"
      [class.tw-h-6]="!isFullPage()"
      [class.tw-w-6]="!isFullPage()"
      [class.tw-bg-transparent]="!isFullPage()"
      [class.tw-text-gray-500]="!isFullPage()"
      (click)="close()"
    >
      @if (isFullPage()) {
        <img src="/assets/icons/arrow_back.svg" alt="" aria-hidden="true" class="tw-h-6 tw-w-6" />
      } @else {
        <img src="/assets/icons/close.svg" alt="" aria-hidden="true" class="tw-h-6 tw-w-6 paid-past-query-close-icon" />
      }
    </button>
    <h2
      class="tw-text-300 tw-font-medium tw-text-gray-800"
      [class.tw-order-1]="!isFullPage()"
      [class.tw-order-2]="isFullPage()"
    >@if (recentQueries().length) { <span i18n="@@recentSupportTickets">Recent Queries</span> } @else { <span i18n="@@pastQueries">Past Queries</span> }</h2>
  </header>

  <div
    #queryList
    class="tw-min-h-0 tw-flex-1 tw-overflow-y-auto tw-px-6 tw-pb-6"
  >
    @if (recentQueries().length) {
      @for (query of recentQueries(); track query.objectId || $index) {
        <article
          class="tw-mb-3 tw-cursor-pointer tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-p-4 tw-shadow-z13"
          role="button"
          tabindex="0"
          (click)="openQuery(query)"
          (keydown.enter)="openQuery(query)"
          (keydown.space)="openQuery(query); $event.preventDefault()"
        >
          <div class="tw-mb-3 tw-flex tw-items-center tw-justify-between tw-text-100 tw-text-gray-400">
            <span>{{ getQueryCategory(query) }}</span>
            <span>{{ query.createdAt | date: 'dd MMM yyyy, hh:mm a' }}</span>
          </div>
          <p class="tw-border-b tw-border-gray-300 tw-pb-3 tw-text-300 tw-text-gray-800">{{ getQueryTitle(query) }}</p>
          <div class="tw-flex tw-items-center tw-justify-between tw-pt-2 tw-text-200 tw-text-teal-600">
            <span class="tw-text-red-400" i18n="@@paidHelpOpenTicket">OPEN</span>
            <img src="/assets/icons/chevron_right_teal.svg" class="tw-h-4 tw-w-4" alt="" />
          </div>
        </article>
      }
    }
    @if (pastQueries().length) {
      @if (recentQueries().length) {
        <h3 class="paid-past-query-section-title" i18n="@@pastQueries">Past Queries</h3>
      }
      @for (query of pastQueries(); track query.objectId || $index) {
        <article
          class="tw-mb-3 tw-cursor-pointer tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-p-4 tw-shadow-z13"
          role="button"
          tabindex="0"
          (click)="openQuery(query)"
          (keydown.enter)="openQuery(query)"
          (keydown.space)="openQuery(query); $event.preventDefault()"
        >
          <div class="tw-mb-3 tw-flex tw-items-center tw-justify-between tw-text-100 tw-text-gray-400">
            <span>{{ getQueryCategory(query) }}</span>
            <span>{{ query.createdAt | date: 'dd MMM yyyy, hh:mm a' }}</span>
          </div>
          <p class="tw-border-b tw-border-gray-300 tw-pb-3 tw-text-300 tw-text-gray-800">{{ getQueryTitle(query) }}</p>
          <div class="tw-flex tw-items-center tw-justify-between tw-pt-2 tw-text-200 tw-text-teal-600">
            <span class="tw-text-teal-600" i18n="@@paidHelpResolved">RESOLVED</span>
            <img src="/assets/icons/chevron_right_teal.svg" class="tw-h-4 tw-w-4" alt="" />
          </div>
        </article>
      }
    }
  </div>
</section>
